
import { Component, Prop, Vue } from 'vue-property-decorator'
import { Observer } from 'mobx-vue'
import { Bind, Debounce } from 'lodash-decorators'
import { courseBan } from '@xt/client/utils/course/ban'
import batchInterval from '@xt/client/utils/countdown/batch-interval'
import { EnumOrderButtonType } from '@xt/client/enums'
import lazyImg from '@xt/www/components/lazyImg/index.vue'
import HeaderImage from '@xt/www/components/headerImage/index.vue'
import OrderButton from '../OrderButton/index.vue'

import type { OrderItem as OrderItemType } from '@xt/client/entities/my-v2/types.d'

type Countdown = {
  hours: string
  minutes: string
  seconds: string
}

@Observer
@Component({
  components: {
    lazyImg,
    HeaderImage,
    OrderButton
  }
})
export default class OrderItem extends Vue {
  @Prop({ required: true }) item: OrderItemType

  /**
   * 拼团倒计时
   */
  groupCountdown: Countdown = {
    hours: '00',
    minutes: '00',
    seconds: '00'
  }

  /**
   * 待支付订单倒计时
   */
  notPayCountdown: Countdown = {
    hours: '00',
    minutes: '00',
    seconds: '00'
  }

  get PageStore() {
    return this.$store.$myV2.Account.Order
  }

  @Bind()
  onGroupCountdownTick() {
    if (!this.item.group) return

    const { isEnd, hours, seconds, minutes } = this.PageStore.mapCountdown(this.item.group.groupEndTime)

    this.groupCountdown = {
      hours,
      minutes,
      seconds
    }

    if (isEnd) {
      batchInterval.removeTask(this.onGroupCountdownTick)
      this.$emit('on-tick-end')
    }
  }

  @Bind()
  onOrderCountdownTick() {
    if (!this.item.showOrderCountdown) return

    const { isEnd, hours, seconds, minutes } = this.PageStore.mapCountdown(this.item.orderEndTime)

    this.notPayCountdown = {
      hours,
      seconds,
      minutes
    }

    if (isEnd) {
      batchInterval.removeTask(this.onOrderCountdownTick)
      this.$emit('on-tick-end')
    }
  }

  onCopyOrderId() {
    const style = 'position: fixed;z-index: -2;top: -9999px'
    let input = document.createElement('input')
    input.value = this.item.orderNo
    input.setAttribute('style', style)
    document.body.appendChild(input)
    input.focus()
    input.select()
    if (document.execCommand('copy', false, undefined)) {
      this.$msg('复制成功', 'success')
    } else {
      this.$msg('请手动复制订单编号')
    }
    document.body.removeChild(input)
  }

  handleClickBtn(type: EnumOrderButtonType) {
    this.$emit('click-btn', { item: this.item, btnType: type })
  }

  @Debounce(300, { leading: true, trailing: false })
  @Bind()
  async hanldeClickItemBody() {
    // 检测课程是否在ban列表中，如果在ban列表中则直接toast "课程已结束"
    const isBan = await courseBan.isBan(this.item.raw.productId)
    if (isBan) {
      this.$msg('课程已结束')
      return
    }

    return this.$router.push({
      path: this.item.raw.activityPageUrl ? this.item.raw.activityPageUrl : `/commodity/${this.item.raw.productId}`
    })
  }

  hanldeShowOrderDetail() {
    this.$emit('show-order-detail', { item: this.item })
  }

  created() {}
  mounted() {
    if (this.item.group?.showInterval) {
      batchInterval.addTask(this.onGroupCountdownTick)
    }

    if (this.item.showOrderCountdown) {
      batchInterval.addTask(this.onOrderCountdownTick)
    }
  }
  updated() {}
  destroyed() {
    batchInterval.removeTask(this.onGroupCountdownTick)
    batchInterval.removeTask(this.onOrderCountdownTick)
  }
}
